import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  AddressCardComponent,
  AdvancedContactSearchDialogComponent,
  AssociateDialogComponent,
  AssociatesComponent,
  AttachmentComponent,
  AttachmentDialogComponent,
  BreadCrumbComponent,
  ClientContactCardComponent,
  GridSumComponent,
  LabelAddressCardComponent,
  LabelContactCardComponent,
  LoanoutDialogComponent,
  LoanoutsComponent,
  LocationContactCardComponent,
  NoteComponent,
  NoteDialogComponent,
  PaymentGenerateDialogComponent,
  PaymentGeneratorComponent,
  PaymentScheduleDialogComponent,
  VenueContactCardComponent,
} from '@hub/components/v1/_common';
import { BatchErrorsComponent } from '@hub/components/v1/_common/batch-errors.component';
import { ContactCardComponent } from '@hub/components/v1/_common/contact-cards/contact-card.component';
import { NestedTabComponent } from '@hub/components/v1/_common/nested-tab/nested-tab.component';
import { TabFooterComponent } from '@hub/components/v1/_common/tab-footer/tab-footer.component';
import { TabViewComponent } from '@hub/components/v1/_common/tab-view/tab-view.component';
import {
  ForbiddenComponent,
  LoginComponent,
  LogoutComponent,
  UserLoginComponent,
  CustomErrorComponent,
} from "@hub/components/v1/authetication/index";
import { RcCalendarComponent } from "@hub/components/v1/calendar/rc-calendar/rc-calendar.component";
import * as filter from "@hub/components/v1/filter/index";
import { TagComponent } from "@hub/components/v1/form-components/form-multiselect/tag/tag.component";
import * as form from "@hub/components/v1/form-components/index";
import * as grid from "@hub/components/v1/grid/index";
import { CurrencyFormatterDirective } from "@hub/directives/currencyFormatter.directive";
import { FullPageLoaderDirective } from "@hub/directives/FullPageLoader.directives";
import { FormEventDirective } from "@hub/directives/formEvent.directive";
import { ValidationDirective } from "@hub/directives/validation.directive";
import { CurrencyInputPipe } from "@hub/pipes/CurrencyInput.pipe";
import { CurrencyThousandPipe } from "@hub/pipes/CurrencyThousand.pipe";
import { DateToUserTimeZonePipe } from "@hub/pipes/DateToUserTimeZone.pipe";
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ErrorMessageComponent } from "@hub/components/v1/error-message/error-message.component";
import { ShowingAmountPipe } from "@hub/pipes/ShowingAmount.pipe";
import { DateTimePipe } from "@hub/pipes/DateTime.pipe";
import { NgSelectModule } from '@ng-select/ng-select';
import { TagListComponent } from '@hub/components/v1/form-components/index';
import { DragulaModule } from 'ng2-dragula';
import { MapToPLabelipe } from '@hub/pipes/MapToLabel.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    AutoCompleteModule,
    CalendarModule,
    DropdownModule,
    FileUploadModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    OverlayPanelModule,
    TriStateCheckboxModule,
    TooltipModule,
    TableModule,
    PaginatorModule,
    ProgressSpinnerModule,
    SidebarModule,
    RouterModule,
    AgmCoreModule,
    DragulaModule
  ],
  declarations: [
    BatchErrorsComponent,
    ForbiddenComponent,
    LoginComponent,
    LogoutComponent,
    UserLoginComponent,
    TagListComponent,
    TagComponent,
    CustomErrorComponent,
    // Grid
    grid.GridOptionComponent,
    grid.GridDialogComponent,
    grid.GridContentComponent,
    grid.ColumnAddressComponent,
    grid.ColumnCheckboxComponent,
    grid.ColumnCurrencyComponent,
    grid.ColumnCurrencyAmountComponent,
    grid.ColumnDateComponent,
    grid.ColumnDateTimeComponent,
    grid.ColumnDropdownComponent,
    grid.ColumnEmailComponent,
    grid.ColumnHyperlinkComponent,
    grid.ColumnHyperlinkListComponent,
    grid.ColumnFaIconComponent,
    grid.ColumnPlainTextComponent,
    grid.ColumnListComponent,
    grid.ColumnImageComponent,
    grid.GridOptionWrapperComponent,
    grid.GridWrapperComponent,
    grid.GridSettingsComponent,
    grid.GridSettingsColumnsComponent,
    grid.GridSettingsOptionComponent,
    grid.SimpleGridComponent,
    grid.SubGridComponent,
    grid.GridHeaderRedirectComponent,
    grid.GridQuickSearchComponent,

    // common
    TabViewComponent,
    NestedTabComponent,
    TabFooterComponent,
    ContactCardComponent,
    AddressCardComponent,
    ClientContactCardComponent,
    VenueContactCardComponent,
    LocationContactCardComponent,
    LabelContactCardComponent,
    LabelAddressCardComponent,
    GridSumComponent,
    LoanoutsComponent,
    LoanoutDialogComponent,
    AssociatesComponent,
    AssociateDialogComponent,
    NoteComponent,
    NoteDialogComponent,
    AttachmentComponent,
    AttachmentDialogComponent,
    BreadCrumbComponent,
    PaymentGeneratorComponent,
    PaymentGenerateDialogComponent,
    PaymentScheduleDialogComponent,
    AdvancedContactSearchDialogComponent,

    // Filter
    filter.FilterHolderComponent,
    filter.FilterSelectorComponent,
    filter.FilterSearchComponent,
    filter.FilterCheckBoxComponent,
    filter.FilterSingleSelectComponent,
    filter.FilterMultiSelectComponent,
    filter.FilterPickerContactComponent,
    filter.FilterPickerEnumComponent,
    filter.FilterDateComponent,
    filter.FilterDateBetweenComponent,
    filter.FilterNgMultiSelectComponent,
    filter.FilterSingleSelectSearchComponent,
    filter.FilterNgMultiSelectSearchComponent,

    // Form
    form.FormAutocompleteComponent,
    form.FormCheckBoxComponent,
    form.FormDatepickerComponent,
    form.FormDropdownComponent,
    form.FormDropzoneComponent,
    form.FormInputComponent,
    form.FormCurrencyComponent,
    form.FormInputSwitchComponent,
    form.FormTextareaComponent,
    form.ResetBtnComponent,
    form.FormMultiSelectComponent,
    form.FormMultiSelectComponent2,
    form.FormContactpickerComponent,
    form.FormColumnComponent,
    form.FormGroupComponent,
    form.FormFooterComponent,
    form.FormRadioComponent,
    form.FormTimepickerComponent,
    form.FormHyperlinkComponent,

    form.FormMultipickerComponent,
    form.FormContactCardComponent,

    ErrorMessageComponent,
    RcCalendarComponent,

    // Pipes
    CurrencyInputPipe,
    CurrencyThousandPipe,
    DateToUserTimeZonePipe,
    DateTimePipe,
    ShowingAmountPipe,
    MapToPLabelipe,

    // Directives
    ValidationDirective,
    FormEventDirective,
    CurrencyFormatterDirective,
    FullPageLoaderDirective
  ],
  exports: [
    BatchErrorsComponent,
    ForbiddenComponent,
    LogoutComponent,
    UserLoginComponent,
    TagComponent,
    TagListComponent,
    CustomErrorComponent,

    // Grid
    grid.GridOptionComponent,
    grid.GridDialogComponent,
    grid.GridContentComponent,
    grid.ColumnAddressComponent,
    grid.ColumnCheckboxComponent,
    grid.ColumnCurrencyComponent,
    grid.ColumnCurrencyAmountComponent,
    grid.ColumnDateComponent,
    grid.ColumnDateTimeComponent,
    grid.ColumnDropdownComponent,
    grid.ColumnEmailComponent,
    grid.ColumnHyperlinkComponent,
    grid.ColumnHyperlinkListComponent,
    grid.ColumnFaIconComponent,
    grid.ColumnPlainTextComponent,
    grid.ColumnListComponent,
    grid.ColumnImageComponent,
    grid.GridOptionWrapperComponent,
    grid.GridWrapperComponent,
    grid.GridSettingsComponent,
    grid.GridSettingsColumnsComponent,
    grid.GridSettingsOptionComponent,
    grid.SimpleGridComponent,
    grid.GridHeaderRedirectComponent,
    grid.SubGridComponent,
    grid.GridQuickSearchComponent,

    // Filter
    filter.FilterHolderComponent,
    filter.FilterSelectorComponent,
    filter.FilterSearchComponent,
    filter.FilterCheckBoxComponent,
    filter.FilterMultiSelectComponent,
    filter.FilterSingleSelectComponent,
    filter.FilterPickerContactComponent,
    filter.FilterPickerEnumComponent,
    filter.FilterDateComponent,
    filter.FilterDateBetweenComponent,
    filter.FilterNgMultiSelectComponent,
    filter.FilterSingleSelectSearchComponent,
    filter.FilterNgMultiSelectSearchComponent,

    // Form
    form.FormAutocompleteComponent,
    form.FormCheckBoxComponent,
    form.FormDatepickerComponent,
    form.FormDropdownComponent,
    form.FormDropzoneComponent,
    form.FormInputComponent,
    form.FormCurrencyComponent,
    form.FormInputSwitchComponent,
    form.FormTextareaComponent,
    form.ResetBtnComponent,
    form.FormMultiSelectComponent,
    form.FormMultiSelectComponent2,
    form.FormContactpickerComponent,
    form.FormColumnComponent,
    form.FormGroupComponent,
    form.FormFooterComponent,
    form.FormTimepickerComponent,
    form.FormRadioComponent,
    form.FormHyperlinkComponent,
    form.FormMultipickerComponent,
    form.FormContactCardComponent,

    // common
    TabViewComponent,
    NestedTabComponent,
    ContactCardComponent,
    AddressCardComponent,
    ClientContactCardComponent,
    VenueContactCardComponent,
    LocationContactCardComponent,
    LabelContactCardComponent,
    LabelAddressCardComponent,
    GridSumComponent,
    LoanoutsComponent,
    LoanoutDialogComponent,
    AssociatesComponent,
    AssociateDialogComponent,

    ErrorMessageComponent,
    RcCalendarComponent,
    NoteComponent,
    NoteDialogComponent,
    AttachmentComponent,
    AttachmentDialogComponent,
    BreadCrumbComponent,
    PaymentGeneratorComponent,
    PaymentGenerateDialogComponent,
    PaymentScheduleDialogComponent,
    AdvancedContactSearchDialogComponent,

    // Pipes
    CurrencyInputPipe,
    CurrencyThousandPipe,
    DateToUserTimeZonePipe,
    ShowingAmountPipe,
    MapToPLabelipe,

    // Directives
    ValidationDirective,
    FormEventDirective,
    CurrencyFormatterDirective,
    FullPageLoaderDirective,
  ]
})
export class SharedModule {
}
